// THE GSTIN FORMAT CHECK -- ADVISORY, NEVER A BLOCKER.
//
// One rule, shared by Settings > Company and the customer details form, so the
// two screens cannot disagree about what "looks like a GSTIN" means. A GSTIN
// this app has never seen must still save: the backend refuses nothing on
// format, and neither may a screen.
//
// 2-digit state code, 10-char PAN, 1 entity digit, "Z", 1 checksum char.
export const GSTIN_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

/** True when a NON-BLANK value does not look like a GSTIN. Blank is fine. */
export function gstinLooksWrong(value: string | null | undefined): boolean {
  const v = (value ?? "").trim().toUpperCase();
  return v !== "" && !GSTIN_RE.test(v);
}
